import qs from 'querystring'
import Api from '../lib/request'
import CONSTANT from '../constant/cookie'
import cookie from '../lib/cookie'
import _ from 'underscore'
const emptyOrderListData = {
    page:{
      pageNum: 0,
      total: 0,
    },
    list: [],
  }
const getGiftOrderList = (data) => {
    return new Promise( (resolve, reject)=> {

        let query = ''
        if(!_.isEmpty(data)){
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`
        // url = 'http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/gift/order-list'
        Api.get(url ,{
            headers: {
                'X-Host':'mall.gift.order-list',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status == 6003) {
            return resolve(emptyOrderListData)
            }
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getGiftOrderDetail = (data) => {
    return new Promise( (resolve, reject)=> {

        let query = ''
        if(!_.isEmpty(data)){
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`
        // url = 'http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/gift/order-info'
        Api.get(url ,{
            headers: {
                'X-Host':'mall.gift.order-info',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getShareLink = (data) => {
    return new Promise( (resolve, reject)=> {
        let query = ''
        if(!_.isEmpty(data)){
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`
        Api.get(url ,{
            headers: {
                'X-Host':'mall.gift.share-link',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const receiveGift = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.gift.receive',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getGiftreceiveInfo = (data) => {
    return new Promise( (resolve, reject)=> {

        // data = JSON.stringify(data)
        // let url = CONSTANT.REQUEST_HOST
        let query = ''
        if (!_.isEmpty(data)) {
          query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`

        Api.get(url, {
            headers: {
                'X-Host':'mall.gift.receive-info',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}

// 礼物领取页
const getGiftReceiveInfo = data => {
    return new Promise( (resolve, reject)=> {
        let query = ''
        if(!_.isEmpty(data)){
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`

        Api.get(url ,{
            headers: {
                'X-Host':'mall.gift.receive-info',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}

// 礼物banner
const getGiftBanner = data => {
    return new Promise( (resolve, reject)=> {
        let query = ''
        if(!_.isEmpty(data)){
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`

        Api.get(url ,{
            headers: {
                'X-Host':'mall.cfg.common-banner',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}

// 生成礼物
const createGift = data => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host': 'mall.order.verify.v2',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}

// 上传语音

const uploadGiftVoice = data => {
    return new Promise( (resolve, reject)=> {

        let url = CONSTANT.REQUEST_HOST
        Api.post(url ,data,{
            headers: {
                'X-Host': 'mall.file.upload',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
// 取消礼物订单
const cancelGiftOrder = data => {
    return new Promise( (resolve, reject)=> {
        let url = CONSTANT.REQUEST_HOST
        Api.post(url, JSON.stringify(data), {
            headers: {
                'X-Host': 'mall.gift.order.cancel',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
// 获取微信语音链接
const getWxAudioLink = data => {
    return new Promise( (resolve, reject)=> {
        let url = CONSTANT.REQUEST_HOST
        Api.post(url, JSON.stringify(data), {
            headers: {
                'X-Host': 'mall.media.media.wechat-media-upload',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
                'Content-Type': 'application/json'
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}

/*yeoman-template-point-1*/
export default {
    getGiftOrderList,
    getGiftOrderDetail,
    getGiftReceiveInfo,
    getShareLink,
    receiveGift,
    getGiftreceiveInfo,
    getGiftBanner,
    createGift,
    uploadGiftVoice,
    cancelGiftOrder,
    getWxAudioLink
/*yeoman-template-point-2*/
}
